import { useEffect, useRef } from 'react';
import { DEFAULT_SCROLL_TO_HOUR } from '../constants';

export function useScrollToHour(hour: number = DEFAULT_SCROLL_TO_HOUR) {
  const scrollTargetRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const element = scrollTargetRef.current;
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [hour]);

  return { scrollTargetRef };
}
